<main>
    <section class="first_screen">
        <div class="page">
            <h1><span>{{'offerWindow.best-proposal' | translate}}</span></h1>
            <form class="search_block">
                <!-- open = class extended -->
                <div class="tag_search_bar">
                    <div class="selected_tag_list">
                        <!-- <span class="undefined item">Category <i>x</i></span>
								<span class="undefined item">Category <i>x</i></span>
								<span class="undefined item">Category <i>x</i></span> -->
                        <input type="text" placeholder="The Wave, Arizona">
                    </div>
                    <button>{{'offerWindow.go' | translate}} ></button>
                </div>
                <div class="tag_explorer">
                    <div class="side_bar_tag_list">
                        <a href="#">Adventure Safari <span>></span></a>
                        <a href="#">Wedding & Marriage <span>></span></a>
                        <a href="#">Hotels & Resorts <span>></span></a>
                        <a href="#">Lodges & Camps <span>></span></a>
                        <a class="active" href="#">Travel category <span>></span></a>
                        <a href="#">Round trips <span>></span></a>
                        <a href="#">Social & Sustainable <span>></span></a>
                        <a href="#">Specials <span>></span></a>
                        <a href="#">Hotels & Resorts <span>></span></a>
                        <a href="#">Hotels & Resorts <span>></span></a>
                        <a href="#">Hotels & Resorts <span>></span></a>
                        <a href="#">Hotels & Resorts <span>></span></a>
                    </div>
                    <div class="tag_box_list_container">
                        <div class="top flex_block">
                            <div class="title">Travel category</div>
                            <div class="adventures">
                                ADVENTURES
                                <img src="../../assets/img/menu-icon.png" width="32" height="32" alt="">
                            </div>
                        </div>
                        <div class="tag_box_list">
                            <input class="checkbox" type="checkbox" checked id="i1" name="name">
                            <label for="i1" class="tag_box active">
										<div class="image">
											<svg width="68" height="40"><use xlink:href="#sun"></use></svg>
										</div>
										<div class="text">Adrenaline</div>
										<i></i>
									</label>
                            <input class="checkbox" type="checkbox" id="i2" name="name">
                            <label for="i2" class="tag_box">
										<div class="image">
											<svg width="70" height="55"><use xlink:href="#camel"></use></svg>
										</div>
										<div class="text">Natural phenomena</div>
										<i></i>
									</label>
                            <input class="checkbox" type="checkbox" id="i3" name="name">
                            <label for="i3" class="tag_box">
										<div class="image">
											<svg width="70" height="38"><use xlink:href="#fish"></use></svg>
										</div>
										<div class="text">Wildlife & safariena</div>
										<i></i>
									</label>
                            <input class="checkbox" type="checkbox" id="i4" name="name">
                            <label for="i4" class="tag_box">
										<div class="image">
											<svg width="47" height="71"><use xlink:href="#air_baloon"></use></svg>
										</div>
										<div class="text">Trekking & hiking</div>
										<i></i>
									</label>
                        </div>
                        <div class="tag_children_list">
                            <div class="scroll">
                                <div class="col">
                                    <input class="checkbox" type="checkbox" id="i11" name="name">
                                    <label for="i11">
												Canopy
											</label>
                                    <input class="checkbox" type="checkbox" id="i33" name="name">
                                    <label for="i33">
												Canyoning
											</label>
                                    <input class="checkbox" type="checkbox" id="i22" name="name">
                                    <label for="i22">
												Drift car
											</label>
                                    <input class="checkbox" type="checkbox" id="i111" name="name">
                                    <label for="i111">
												Parks
											</label>
                                    <input class="checkbox" type="checkbox" id="iq" name="name">
                                    <label for="iq">
												Hot air ballon
											</label>
                                </div>
                                <div class="col">
                                    <input class="checkbox" type="checkbox" id="iw" name="name">
                                    <label for="iw">
												Canopy
											</label>
                                    <input class="checkbox" type="checkbox" id="iww" name="name">
                                    <label for="iww">
												Canyoning
											</label>
                                    <input class="checkbox" type="checkbox" id="ww" name="name">
                                    <label for="ww">
												Drift car
											</label>
                                    <input class="checkbox" type="checkbox" id="www" name="name">
                                    <label for="www">
												Parks
											</label>
                                    <input class="checkbox" type="checkbox" id="w" name="name">
                                    <label for="w">
												Hot air ballon
											</label>
                                </div>
                                <div class="col">
                                    <input class="checkbox" type="checkbox" id="ir" name="name">
                                    <label for="ir">
												Canopy
											</label>
                                    <input class="checkbox" type="checkbox" id="r" name="name">
                                    <label for="r">
												Canyoning
											</label>
                                    <input class="checkbox" type="checkbox" id="rr" name="name">
                                    <label for="rr">
												Drift car
											</label>
                                    <input class="checkbox" type="checkbox" id="rr" name="name">
                                    <label for="rr">
												Parks
											</label>
                                    <input class="checkbox" type="checkbox" id="ri1" name="name">
                                    <label for="ri1">
												Hot air ballon
											</label>
                                </div>
                                <div class="col">
                                    <input class="checkbox" type="checkbox" id="wi1" name="name">
                                    <label for="wi1">
												Canopy
											</label>
                                    <input class="checkbox" type="checkbox" id="qi1" name="name">
                                    <label for="qi1">
												Canyoning
											</label>
                                    <input class="checkbox" type="checkbox" id="iq" name="name">
                                    <label for="iq">
												Drift car
											</label>
                                    <input class="checkbox" type="checkbox" id="q" name="name">
                                    <label for="q">
												Parks
											</label>
                                    <input class="checkbox" type="checkbox" id="fi1" name="name">
                                    <label for="fi1">
												Hot air ballon
											</label>
                                </div>
                                <div class="col">
                                    <input class="checkbox" type="checkbox" id="wi1" name="name">
                                    <label for="wi1">
												Canopy
											</label>
                                    <input class="checkbox" type="checkbox" id="qi1" name="name">
                                    <label for="qi1">
												Canyoning
											</label>
                                    <input class="checkbox" type="checkbox" id="iq" name="name">
                                    <label for="iq">
												Drift car
											</label>
                                    <input class="checkbox" type="checkbox" id="q" name="name">
                                    <label for="q">
												Parks
											</label>
                                    <input class="checkbox" type="checkbox" id="fi1" name="name">
                                    <label for="fi1">
												Hot air ballon
											</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="benefits">
            <h2 class="title_pages">{{'offerWindow.our-benefits' | translate}}</h2>
            <div class="flex_block items page">
                <div class="item">
                    <img src="../../assets/img/benefits_1.png" width="88" height="88" alt="">
                    <div class="text">{{'offerWindow.no-fees' | translate}}</div>
                </div>
                <div class="item">
                    <img src="../../assets/img/benefits_2.png" width="100" height="88" alt="">
                    <div class="text">{{'offerWindow.easy-and-fast' | translate}}</div>
                </div>
                <div class="item">
                    <img src="../../assets/img/benefits_3.png" width="88" height="88" alt="">
                    <div class="text">{{'offerWindow.round-the-clock-support' | translate}}</div>
                </div>
                <div class="item">
                    <img src="../../assets/img/benefits_4.png" width="88" height="88" alt="">
                    <div class="text">{{'offerWindow.with-us-safely' | translate}}</div>
                </div>
                <div class="item">
                    <img src="../../assets/img/benefits_5.png" width="91" height="88" alt="">
                    <div class="text">{{'offerWindow.subscribe-new-tour' | translate}}</div>
                </div>
            </div>
        </div>
    </section>
    <!--<section *ngIf="!admin" class="new_in_programm offer_window">-->
    <!--<section *ngIf="!admin; else elseBlock" class="new_in_programm">-->

    <h2 id="offer-window-title" class="title_pages">{{'offerWindow.title' | translate}}</h2>
    <!-- {{'Title' | translate}} -->
    <div class="container" id="tourpackages-carousel">

        <div class="row">
            <!-- <div *ngFor="let travel of responseData; let i = index" class="col-xs-18 col-sm-6 col-md-6 col-lg-3">
                <div class="thumbnail">
                    <img *ngIf="i === 0" src={{imgSrc}} alt="">
                    <img *ngIf="i === 1" src={{imgSrc1}} alt="">
                    <img *ngIf="i === 2" src={{imgSrc2}} alt="">
                    <img *ngIf="i === 3" src={{imgSrc3}} alt="">

                    <div class="caption">
                        <app-star-comonent [category]="travel[userType].accommodation.category"></app-star-comonent>
                        <h3 id="header1">{{travel[userType].header}} </h3>
                        <h4>{{travel[userType].subHeader}}</h4>
                        <h5>{{travel[userType].subText}}</h5>
                        <p class='detail_page' [innerHTML]="travel[userType].shortText | safeHtml"></p>

                        <p id="text_div"> ab {{price}} p.P.</p>
                        <p id="push-to-bottom">
                            <a class="btn btn-info btn-xs" *ngIf="premium" role="button" (click)="onDetails(id)">Details</a>
                            <a class="btn btn-info btn-xs" *ngIf="!premium" role="button" (click)="onInquiry(id)">Inquiry</a>
                            <a class="btn btn-warning btn-xs" *ngIf="admin && premium " role="button" (click)="onSelect(baseForAdminPage+ '/products/simpleTravel/'+ id)">Configure</a>
                        </p>

                    </div>
                </div>
            </div> -->
            <div class="col-xs-18 col-sm-6 col-md-3" *ngIf="id == null; else elseMock">
                <div class="thumbnail">
                    <img src="https://placehold.it/500x300" alt="">
                    <div class="caption">
                        <h4>Error occurred </h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
                    </div>
                </div>
            </div>
            <ng-template #elseMock>
                <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3">
                    <div class="thumbnail">
                        <img src={{imgSrc}} alt="">
                        <div class="caption">
                            <app-star-comonent [category]="category"></app-star-comonent>
                            <h3 id="header1">{{header}} </h3>
                            <h4>{{subHeader}}</h4>
                            <h5>{{subText}}</h5>
                            <h5>{{subTextI}} </h5>
                            <p class='detail_page' [innerHTML]="shortText | safeHtml"></p>

                            <p id="text_div"> ab {{price}} p.P.</p>
                            <p id="push-to-bottom">
                                <a class="btn btn-info btn-xs" *ngIf="premium" role="button" (click)="onDetails(id)"> {{'offerWindow.details-btn' | translate}}</a>
                                <a class="btn btn-info btn-xs" *ngIf="!premium" role="button" (click)="onInquiry(id)">{{'offerWindow.inquiry-btn' | translate}}</a>
                                <a class="btn btn-warning btn-xs" *ngIf="admin" role="button" (click)="onSelect(baseForAdminPage+ '/products/simpleTravel/'+ id)">{{'offerWindow.configure-btn' | translate}}</a>
                            </p>

                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3" *ngIf="id1 == null; else elseMock1">
                <div class="thumbnail">
                    <img src="https://placehold.it/500x300" alt="">
                    <div class="caption">
                        <h4>Error occurred </h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
                    </div>
                </div>
            </div>
            <ng-template #elseMock1>
                <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3">
                    <div class="thumbnail">
                        <img src={{imgSrc1}} alt="">
                        <div class="caption">
                            <app-star-comonent [category]="category1"></app-star-comonent>

                            <h3>{{header1}} </h3>
                            <h4>{{subHeader1}}</h4>
                            <h5>{{subText1}}</h5>
                            <h5>{{subText1I}} </h5>
                            <p class='detail_page' [innerHTML]="shortText1 | safeHtml"></p>

                            <p id="text_div"> ab {{price1}} p.P.</p>
                            <p id="push-to-bottom">
                                <a class="btn btn-info btn-xs" *ngIf="premium" role="button" (click)="onDetails(id1)">{{'offerWindow.details-btn' | translate}}</a>
                                <a class="btn btn-info btn-xs" *ngIf="!premium" role="button" (click)="onInquiry(id1)">{{'offerWindow.inquiry-btn' | translate}}</a>
                                <a class="btn btn-warning btn-xs" *ngIf="admin" role="button" (click)="onSelect(baseForAdminPage+ '/products/simpleTravel/'+ id1)">{{'offerWindow.configure-btn' | translate}}</a>
                            </p>
                        </div>
                    </div>
                </div>

            </ng-template>
            <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3" *ngIf="id2 == null; else elseMock2">
                <div class="thumbnail">
                    <img src="https://placehold.it/500x300" alt="">
                    <div class="caption">
                        <h4>Error occurred </h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
                    </div>
                </div>
            </div>
            <ng-template #elseMock2>
                <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3">
                    <div class="thumbnail">
                        <img src={{imgSrc2}} alt="">
                        <div class="caption">
                            <app-star-comonent [category]="category2"></app-star-comonent>
                            <h3>{{header2}}</h3>
                            <h4>{{subHeader2}}</h4>
                            <h5>{{subText2}}</h5>
                            <h5>{{subText2I}} </h5>
                            <p class='detail_page' [innerHTML]="shortText2 | safeHtml"></p>

                            <p id="text_div"> ab {{price2}} p.P.</p>
                            <p id="push-to-bottom">
                                <a class="btn btn-info btn-xs" *ngIf="premium" role="button" (click)="onDetails(id2)">{{'offerWindow.details-btn' | translate}}</a>
                                <a class="btn btn-info btn-xs" *ngIf="!premium" role="button" (click)="onInquiry(id2)">{{'offerWindow.inquiry-btn' | translate}}</a>
                                <a class="btn btn-warning btn-xs" *ngIf="admin" role="button" (click)="onSelect(baseForAdminPage+ '/products/simpleTravel/'+ id2)">{{'offerWindow.configure-btn' | translate}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </ng-template>

            <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3" *ngIf="id3 == null; else elseMock3">
                <div class="thumbnail">
                    <img src="https://placehold.it/500x300" alt="">
                    <div class="caption">
                        <h4>Error occurred </h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Facere, soluta, eligendi doloribus sunt minus amet sit debitis repellat. Consectetur, culpa itaque odio similique suscipit</p>
                    </div>
                </div>
            </div>
            <ng-template #elseMock3>
                <div class="col-xs-18 col-sm-6 col-md-6 col-lg-3">
                    <div class="thumbnail">
                        <img src={{imgSrc3}} alt="">
                        <div class="caption">
                            <app-star-comonent [category]="category3"></app-star-comonent>
                            <h3>{{header3}}</h3>
                            <h4>{{subHeader3}}</h4>
                            <h5>{{subText3}}</h5>
                            <h5>{{subText3I}} </h5>
                            <p class='detail_page' [innerHTML]="shortText3 | safeHtml"></p>

                            <p id="text_div"> ab {{price3}} p.P.</p>
                            <p id="push-to-bottom">
                                <a class="btn btn-info btn-xs" *ngIf="premium" role="button" (click)="onDetails(id3)">{{'offerWindow.details-btn' | translate}}</a>
                                <a class="btn btn-info btn-xs" *ngIf="!premium" role="button" (click)="onInquiry(id3)">{{'offerWindow.inquiry-btn' | translate}}</a>
                                <a class="btn btn-warning btn-xs" *ngIf="admin" role="button" (click)="onSelect(baseForAdminPage+ '/products/simpleTravel/'+ id3)">{{'offerWindow.configure-btn' | translate}}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <section class="video_block">
        <a href="https://player.vimeo.com/video/173893444" class="full_movie fancy fancybox.iframe">
            <img src="../../assets/img/full-movie.jpg" width="1920" height="436" alt="">
            <div class="description">For that moment in the Caribbean</div>
            <div class="play"></div>
        </a>

        <div class="flex_block items page">
            <a href="https://player.vimeo.com/video/173893444" class="item fancy fancybox.iframe active">
                <div class="image">
                    <img src="../../assets/img/trash/11.jpg" alt="">
                    <span class="play"></span>
                </div>
                <div class="text">For that moment in the Caribbean <span>[3:42]</span></div>
            </a>
            <a href="https://player.vimeo.com/video/173893444" class="item fancy fancybox.iframe">
                <div class="image">
                    <img src="../../assets/img/trash/22.jpg" alt="">
                    <span class="play"></span>
                </div>
                <div class="text">For that moment in the Alpine <span>[3:42]</span></div>
            </a>
            <a href="https://player.vimeo.com/video/173893444" class="item fancy fancybox.iframe">
                <div class="image">
                    <img src="../../assets/img/trash/33.jpg" alt="">
                    <span class="play"></span>
                </div>
                <div class="text">For that moment in the Mountains <span>[3:42]</span></div>
            </a>
            <a href="https://player.vimeo.com/video/173893444" class="item fancy fancybox.iframe">
                <div class="image">
                    <img src="../../assets/img/trash/44.jpg" alt="">
                    <span class="play"></span>
                </div>
                <div class="text">For that moment in the Sky <span>[3:42]</span></div>
            </a>
        </div>
    </section>

    <div class="page">
        <section class="travel_recommendations">
            <h2 class="title_pages">Travel recommendations</h2>
            <div class="flex_block items">
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">India / Sri Lanka</div>
                </a>
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">Namibia</div>
                </a>
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">Luxury specials</div>
                </a>
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">La Reunion</div>
                </a>
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">Italy</div>
                </a>
                <a href="#" class="item">
                    <div class="image"><img src="../../assets/img/trash/111.jpg" width="381" height="260" alt=""></div>
                    <div class="text">Hai Tauchen in south Africa</div>
                </a>
            </div>
        </section>


        <section class="subscribe flex_block">
            <div class="text">
                <div class="title">{{'offerWindow.newsletter' | translate}}</div>
                <p>
                    {{'offerWindow.letter' | translate}}
                </p>
            </div>
            <form action="">
                <input type="text">
                <button>{{'offerWindow.subscribe' | translate}}</button>
            </form>
        </section>
    </div>



// WEBPACK FOOTER //
// ./src/app/home/home.component.html